function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H36V24H0V0Z",
  fill: "#016FD0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6937 20.2026V11.6026L36 11.6167V13.9922L34.2307 15.8823L36 17.7906V20.2161H33.1755L31.6745 18.5599L30.1839 20.2229L20.6937 20.2026Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7161 19.2594V12.549H27.4063V14.0948H23.5589V15.1443H27.3146V16.6646H23.5589V17.6953H27.4063V19.2594H21.7161Z",
  fill: "#016FD0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.3781 19.2594L30.526 15.9005L27.3781 12.5495H29.8146L31.7385 14.6761L33.6677 12.5495H36V12.6021L32.9187 15.9005L36 19.1646V19.2594H33.6443L31.6865 17.1115L29.7484 19.2594H27.3781Z",
  fill: "#016FD0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4078 3.96979H25.0974L26.3932 6.9125V3.96979H30.9484L31.7339 6.17447L32.5219 3.96979H36V12.5693H17.6188L21.4078 3.96979Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1068 4.90417L19.1292 11.6089H21.1714L21.7328 10.2662H24.7766L25.338 11.6089H27.4307L24.4656 4.90417H22.1068ZM22.3625 8.76147L23.2552 6.62709L24.1474 8.76147H22.3625Z",
  fill: "#016FD0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.4031 11.6078V4.90314L30.2734 4.91303L31.7505 9.03491L33.2375 4.90314H36V11.6078L34.2224 11.6235V7.01772L32.5443 11.6078H30.9214L29.2083 7.0021V11.6078H27.4031Z",
  fill: "#016FD0"
});

function SvgAmex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.4142288d.svg";
export { ForwardRef as ReactComponent };